/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Who may start the exam session. None = lecturer. self_service = the booked student starts their own session.
 */
export type EventKindStartAuthority = 'lecturer' | 'self_service' | null;
